import React from "react";

import { hunCountryCode } from "lib/build/concepts";

import { CountySelect } from "src/common/components/CountySelect";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import {
	useLogProp,
	useMessageProps,
	useValue
} from "src/features/forms/hooks/useField";
import { CommonProps } from "src/features/forms/types";

export const CountySelectRenderer: React.FunctionComponent<
	CommonProps
> = directProps => {
	const isLocked = React.useContext(IsLockedContext);
	const messageProps = useMessageProps();
	const valueType = useLogProp<string>(messageProps, "value", "");
	const [value, onChangeValue] = useValue<string | undefined>(undefined);
	return (
		<CountySelect
			{...directProps}
			disabled={isLocked}
			country={valueType === "hunCounty" ? hunCountryCode : "other"}
			value={value}
			onChangeValue={onChangeValue}
		/>
	);
};
